import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import OwnershipTransferPrivateBuyerBlockData from '../../../Models/Content/OwnershipTransferPrivateBuyerBlockData';
import OwnershipTransferBuyer from './OwnershipTransferBuyer';

export default class OwnershipTransferBuyerBlock extends EpiComponent<OwnershipTransferPrivateBuyerBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <OwnershipTransferBuyer iContent={this.props.data} />;
  }
}
